import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Store } from '@ngxs/store';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class AuthService {
    constructor(private router: Router, private store: Store, private http: HttpClient) {

    }

    public getAllAdminList(): Observable<any> {
      let params = new HttpParams();
      params = params.append('pageSize' , 500);
      params = params.append('page' , 0);
      const options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
      };
      const metadataUrl= environment.authUrl + '/gapmaps/user/v2/admin/list'

      return this.http.get(`${metadataUrl}`,  {params: params ,...options})
    }
}
